import { useEffect } from 'react';
import { log } from 'log';
import { path, prop } from 'ramda';
import { useCookieSettingsSelector, useLottoSelector } from 'js/store/hooks';

export const useLottoCookie = () => {
    const statisticsCookie = useCookieSettingsSelector(path(['groupsData', 'statistics']));
    const isAppInitialized = useLottoSelector(prop('isAppInitialized'));

    useEffect(() => {
        if (!window.Lotto || !isAppInitialized) {
            return;
        }

        try {
            window.Lotto.sendMessage('GIVE_COOKIE_CONSENT', { analytics: statisticsCookie });
        } catch (error) {
            log('log', '[LOTTO | Portal] Get cookie error', error);
        }
    }, [statisticsCookie, isAppInitialized]);
};
